import Big from 'big.js';
import * as bootstrap from 'bootstrap';
import { HandleRequestError } from 'smg/errors';
import * as models from 'smg/models';
import * as template from 'smg/template';
import { DollarFormat } from 'smg/util';
import * as carts from '../carts';

interface myWindow extends Window {
    readonly cloudFront: string;
}
declare const window: myWindow;

async function main() {
    await carts.GetCart().
        catch(HandleRequestError).
        then(cartResp => {
            if (!cartResp) {
                return;
            }
            const $yourCartItems = document.querySelector('#your-cart-items') as HTMLElement;
            DrawCartItemPreviewFromCart($yourCartItems, cartResp.cart);
        });
}

if (document.body.id === 'cart-item-preview') {
    void main();
}

interface cartItemPreview {
    name: string;
    quantity: number;
    size: string;
    price: string;
    img?: string;
}

export function DrawCartItemPreviewFromCart($el: HTMLElement, cart: models.Cart): void {
    const $collapsedBodyParent = $el.querySelector<HTMLElement>('.swiper-container');
    const $collapsedBody = $el.querySelector<HTMLElement>('.swiper-wrapper');
    const $expandedBody = $el.querySelector<HTMLElement>('.expanded-view-body');
    const $expandToggle = $el.querySelector<HTMLElement>('.expand-view-toggle');

    if (cart.cartItems?.length === 1) {
        $expandToggle?.classList.add('d-none');
        $expandedBody?.append(...drawExpandedCartItemPreviews(cart));
        $expandedBody?.classList.remove('collapse');
        return;
    } else {
        $expandToggle?.classList.remove('d-none');
        if ($collapsedBodyParent && $collapsedBody && $expandedBody && $expandToggle) {
            $collapsedBody.append(...drawCollapsedCartItemPreviews(previewsFromCart(cart)));
            $expandedBody.append(...drawExpandedCartItemPreviews(cart));
            const $collapsedController = new bootstrap.Collapse($collapsedBodyParent, { toggle: false });
            const $expandedController = new bootstrap.Collapse($expandedBody, { toggle: false });
            $expandToggle.addEventListener('click', () => {
                if ($collapsedBodyParent.classList.contains('show')) {
                    $collapsedController.hide();
                    $expandedController.show();
                    $expandToggle.textContent = 'Collapse View';
                    $expandToggle.classList.add('expanded');
                } else {
                    $collapsedController.show();
                    $expandedController.hide();
                    $expandToggle.textContent = 'Expand View';
                    $expandToggle.classList.remove('expanded');
                }
            });
            setTimeout(() => {
                $collapsedController.show();
                $expandedController.hide();
                $expandToggle.textContent = 'Expand View';
                $expandToggle.classList.remove('expanded');
            });
        }
    }
}

export function DrawCartItemPreviewFromOrder($el: HTMLElement, order: models.Order): void {
    const $collapsedBodyParent = $el.querySelector<HTMLElement>('.swiper-container');
    const $collapsedBody = $el.querySelector<HTMLElement>('.swiper-wrapper');
    const $expandedBody = $el.querySelector<HTMLElement>('.expanded-view-body');
    const $expandToggle = $el.querySelector<HTMLElement>('.expand-view-toggle');

    if (order.orderLineItems?.length === 1) {
        $expandToggle?.classList.add('d-none');
        $expandedBody?.append(...drawExpandedCartItemPreviews(order));
        $expandedBody?.classList.remove('collapse');
        return;
    } else {
        $expandToggle?.classList.remove('d-none');
        if ($collapsedBodyParent && $collapsedBody && $expandedBody && $expandToggle) {
            const collapsedElements = drawCollapsedCartItemPreviews(previewsFromOrder(order));
            if (collapsedElements.length) {
                $collapsedBody.append(...collapsedElements);
            } else {
                const $empty = template.Clone('#cart-item-collapsed-preview-empty-template') as HTMLElement;
                $collapsedBody.append($empty);
            }
            const expandedBody = $el.querySelector('.expanded-view-body') as HTMLElement;
            const expandedPreview = drawExpandedOrderPreview(order, false) ?? template.Clone('#cart-item-expanded-preview-empty-template') as HTMLElement;
            expandedBody.append(expandedPreview);
            const $collapsedController = new bootstrap.Collapse($collapsedBodyParent, { toggle: false });
            const $expandedController = new bootstrap.Collapse($expandedBody, { toggle: false });
            $expandToggle.addEventListener('click', () => {
                if ($collapsedBodyParent.classList.contains('show')) {
                    $collapsedController.hide();
                    $expandedController.show();
                    $expandToggle.textContent = 'Collapse View';
                    $expandToggle.classList.add('expanded');
                } else {
                    $collapsedController.show();
                    $expandedController.hide();
                    $expandToggle.textContent = 'Expand View';
                    $expandToggle.classList.remove('expanded');
                }
            });
            setTimeout(() => {
                $collapsedController.show();
                $expandedController.hide();
                $expandToggle.textContent = 'Expand View';
                $expandToggle.classList.remove('expanded');
            });
        }
    }
}

export function DrawCartItemPreviewFromQuote($el: HTMLElement, quote: models.Quote): void {
    const $collapsedBodyParent = $el.querySelector<HTMLElement>('.swiper-container');
    const $collapsedBody = $el.querySelector<HTMLElement>('.swiper-wrapper');
    const $expandedBody = $el.querySelector<HTMLElement>('.expanded-view-body');
    const $expandToggle = $el.querySelector<HTMLElement>('.expand-view-toggle');
    if (quote.quoteLineItems?.length === 1) {
        $expandToggle?.classList.add('d-none');
        $expandedBody?.append(...drawExpandedCartItemPreviews(quote));
        $expandedBody?.classList.remove('collapse');
        return;
    } else {
        $expandToggle?.classList.remove('d-none');
        if ($collapsedBodyParent && $collapsedBody && $expandedBody && $expandToggle) {
            const collapsedElements = drawCollapsedCartItemPreviews(previewsFromQuote(quote));
            if (collapsedElements.length) {
                $collapsedBody.append(...collapsedElements);
            } else {
                const $empty = template.Clone('#cart-item-collapsed-preview-empty-template') as HTMLElement;
                $collapsedBody.append($empty);
            }
            const expandedBody = $el.querySelector('.expanded-view-body') as HTMLElement;
            const expandedPreview = drawExpandedQuotePreview(quote, false) ?? (template.Clone('#cart-item-expanded-preview-empty-template') as HTMLElement);
            expandedBody.append(expandedPreview);
            const $collapsedController = new bootstrap.Collapse($collapsedBodyParent, { toggle: false });
            const $expandedController = new bootstrap.Collapse($expandedBody, { toggle: false });
            $expandToggle.addEventListener('click', () => {
                if ($collapsedBodyParent.classList.contains('show')) {
                    $collapsedController.hide();
                    $expandedController.show();
                    $expandToggle.textContent = 'Collapse View';
                    $expandToggle.classList.add('expanded');
                } else {
                    $collapsedController.show();
                    $expandedController.hide();
                    $expandToggle.textContent = 'Expand View';
                    $expandToggle.classList.remove('expanded');
                }
            });
            setTimeout(() => {
                $collapsedController.show();
                $expandedController.hide();
                $expandToggle.textContent = 'Expand View';
                $expandToggle.classList.remove('expanded');
            });
        }
    }
}

function previewsFromCart(cart: models.Cart): cartItemPreview[] {
    const out: cartItemPreview[] = [];
    cart.cartItems?.forEach(ci => {
        if (ci.quote) {
            out.push(...previewsFromQuote(ci.quote) ?? []);
        } else if (ci.order) {
            out.push(...previewsFromOrder(ci.order) ?? []);
        }
    });
    return out;
}

function previewsFromQuote(quote: models.Quote): cartItemPreview[] | undefined {
    return quote.quoteLineItems?.map(qli => {
        if (qli.lineItemModel?.product === false) {
            return;
        }
        const out: cartItemPreview = {
            name: 'Item',
            quantity: qli.quantity ?? 1,
            size: qli.lineItemTypeSize?.name || qli.size || '',
            price: '$0.00',
        };
        if (qli.quoteProof?.name) {
            out.name = qli.quoteProof.name;
        } else if (qli.lineItemModel?.name) {
            out.name = qli.lineItemModel.name;
            out.name += ` (${qli.lineItemType?.networkLineItemType?.name || qli.lineItemType?.name || ''})`;
        }
        if (qli.quoteProof?.proof?.file) {
            out.img = `${window.cloudFront}/${qli.quoteProof?.proof?.file}`;
        }
        let price = Big(qli.price ?? 0).times(qli.quantity ?? 1);
        qli.quoteChildLineItems?.forEach(qcli => {
            price = price.add(Big(qcli.price ?? 0).times(qcli.quantity ?? 1));
        });
        out.price = DollarFormat(price);
        return out;
    }).filter(Boolean) as cartItemPreview[];
}

function previewsFromOrder(order: models.Order): cartItemPreview[] | undefined {
    return order.orderLineItems?.map(oli => {
        if (oli.lineItemModel?.product === false) {
            return;
        }
        const out: cartItemPreview = {
            name: 'Item',
            quantity: oli.quantity ?? 1,
            size: oli.lineItemTypeSize?.name || oli.size || '',
            price: '$0.00',
        };
        if (oli.lineItemModel?.name) {
            out.name = oli.lineItemModel.name;
            out.name += ` (${oli.lineItemType?.networkLineItemType?.name || oli.lineItemType?.name || ''})`;
        }
        if (oli.orderProof?.proof?.file) {
            out.img = `${window.cloudFront}/${oli.orderProof?.proof?.file}`;
        }
        let price = Big(oli.price ?? 0).times(oli.quantity ?? 1);
        oli.orderChildLineItems?.forEach(ocli => {
            price = price.add(Big(ocli.price ?? 0).times(ocli.quantity ?? 1));
        });
        out.price = DollarFormat(price);
        return out;
    }).filter(Boolean) as cartItemPreview[];
}

function drawCollapsedCartItemPreviews(items: cartItemPreview[] | undefined): HTMLElement[] {
    return items?.map(item => {
        const $newSlide = template.Clone('#cart-item-collapsed-preview-template') as HTMLElement;
        const $name = $newSlide.querySelector('.item-name') as HTMLElement;
        const $quantity = $newSlide.querySelector('.item-quantity') as HTMLElement;
        const $size = $newSlide.querySelector('.item-size') as HTMLElement;
        const $price = $newSlide.querySelector('.item-price') as HTMLElement;
        const $imgFull = $newSlide.querySelector('.cart-item-preview-img-full') as HTMLAnchorElement;
        const $imgThumb = $newSlide.querySelector('.cart-item-preview-img-thumb') as HTMLImageElement;
        $name.textContent = item.name;
        $quantity.textContent = Intl.NumberFormat().format(item.quantity);
        $size.textContent = item.size;
        $price.textContent = item.price;
        if (item.img) {
            $imgFull.href = item.img;
            $imgFull.setAttribute('data-caption', $name.textContent);
            $imgThumb.src = item.img;
            $imgThumb.alt = $name.textContent;
        } else {
            $imgFull.remove();
            $imgThumb.remove();
        }
        return $newSlide;
    }) ?? [];
}

function drawExpandedCartItemPreviews(cart: models.Cart): HTMLElement[] {
    const elements: (HTMLElement | undefined)[] = [];
    cart.cartItems?.forEach(ci => {
        if (ci.quote) {
            elements.push(drawExpandedQuotePreview(ci.quote));
        } else if (ci.order) {
            elements.push(drawExpandedOrderPreview(ci.order));
        }
    });
    return elements.filter(Boolean) as HTMLElement[];
}

function drawExpandedOrderPreview(order: models.Order, header: boolean = true): HTMLElement | undefined {
    const $newSection = template.Clone('#cart-item-expanded-preview-group-template') as HTMLElement;

    const $newSectionHeader = $newSection.querySelector('h4') as HTMLElement;
    if (header) {
        $newSectionHeader.textContent = `Reorder ${order.invoiceNumber ?? ''}`;
    } else {
        $newSectionHeader.remove();
    }

    const $newSectionBody = $newSection.querySelector('.cart-item-expanded-preview-body') as HTMLElement;
    order.orderLineItems?.forEach(oli => {
        if (oli.lineItemModel?.product === true) {
            const $newItem = template.Clone('#cart-item-expanded-preview-template') as HTMLElement;
            const $name = $newItem.querySelector('.item-name') as HTMLElement;
            const $quantity = $newItem.querySelector('.item-quantity') as HTMLElement;
            const $size = $newItem.querySelector('.item-size') as HTMLElement;
            const $price = $newItem.querySelector('.item-price') as HTMLElement;
            const $imgFull = $newItem.querySelector('.cart-item-preview-img-full') as HTMLAnchorElement;
            const $imgThumb = $newItem.querySelector('.cart-item-preview-img-thumb') as HTMLImageElement;
            $name.textContent = 'Item';
            if (oli.lineItemModel?.name) {
                $name.textContent = oli.lineItemModel.name;
                if (oli.lineItemType?.name) {
                    $name.textContent += ` (${oli.lineItemType.name})`;
                }
            }
            $quantity.textContent = Intl.NumberFormat().format(oli.quantity ?? 1);
            $size.textContent = oli.lineItemTypeSize?.name ?? '';
            let priceVal = Big(oli.price ?? 0).times(oli.quantity ?? 1);
            oli.orderChildLineItems?.forEach(ocli => {
                priceVal = priceVal.add(Big(ocli.price ?? 0).times(ocli.quantity ?? 1));
            });
            $price.textContent = DollarFormat(priceVal);
            if (oli.orderProof?.proof?.file) {
                $imgFull.href = `${window.cloudFront}/${oli.orderProof?.proof?.file}`;
                $imgFull.setAttribute('data-caption', $name.textContent);
                $imgThumb.src = `${window.cloudFront}/${oli.orderProof?.proof?.file}`;
                $imgThumb.alt = $name.textContent;
            } else {
                const $placeholder = document.createElement('div');
                $placeholder.classList.add('cart-item-preview-img');
                $imgFull.replaceWith($placeholder);
            }
            $newSectionBody.append($newItem);
        }
    });

    return $newSection;
}

function drawExpandedQuotePreview(quote: models.Quote, header: boolean = true): HTMLElement | undefined {
    const $newSection = template.Clone('#cart-item-expanded-preview-group-template') as HTMLElement;

    const $newSectionHeader = $newSection.querySelector('h4') as HTMLElement;
    if (header) {
        $newSectionHeader.textContent = `Quote ${quote.serial ?? ''}`;
    } else {
        $newSectionHeader.remove();
    }

    const $newSectionBody = $newSection.querySelector('.cart-item-expanded-preview-body') as HTMLElement;
    quote.quoteLineItems?.forEach(qli => {
        if (qli.lineItemModel?.product === true) {
            const $newItem = template.Clone('#cart-item-expanded-preview-template') as HTMLElement;
            const $name = $newItem.querySelector('.item-name') as HTMLElement;
            const $quantity = $newItem.querySelector('.item-quantity') as HTMLElement;
            const $size = $newItem.querySelector('.item-size') as HTMLElement;
            const $price = $newItem.querySelector('.item-price') as HTMLElement;
            const $imgFull = $newItem.querySelector('.cart-item-preview-img-full') as HTMLAnchorElement;
            const $imgThumb = $newItem.querySelector('.cart-item-preview-img-thumb') as HTMLImageElement;
            $name.textContent = 'Item';
            if (qli.quoteProof?.name) {
                $name.textContent = qli.quoteProof.name;
            } else if (qli.lineItemModel?.name) {
                $name.textContent = qli.lineItemModel.name;
                $name.textContent += ` (${qli.lineItemType?.networkLineItemType?.name || qli.lineItemType?.name || ''})`;
            }
            $quantity.textContent = Intl.NumberFormat().format(qli.quantity ?? 1);
            $size.textContent = qli.lineItemTypeSize?.name ?? '';
            let priceVal = Big(qli.price ?? 0).times(qli.quantity ?? 1);
            qli.quoteChildLineItems?.forEach(qcli => {
                priceVal = priceVal.add(Big(qcli.price ?? 0).times(qcli.quantity ?? 1));
            });
            $price.textContent = DollarFormat(priceVal);
            if (qli.quoteProof?.proof?.file) {
                $imgFull.href = `${window.cloudFront}/${qli.quoteProof?.proof?.file}`;
                $imgFull.setAttribute('data-caption', $name.textContent);
                $imgThumb.src = `${window.cloudFront}/${qli.quoteProof?.proof?.file}`;
                $imgThumb.alt = $name.textContent;
            } else {
                const $placeholder = document.createElement('div');
                $placeholder.classList.add('cart-item-preview-img');
                $imgFull.replaceWith($placeholder);
            }
            $newSectionBody.append($newItem);
        }
    });

    return $newSection;
}
